module.exports = __webpack_public_path__ + "ps.svg?930fc9498126d3f29f21fb79dee9295a";